module.exports = __webpack_public_path__ + "static/img/female-bg-es.23f86773.png";